import { BaseAssertException } from '../exceptions/base-assert.exception';
import { IllegalArgumentException } from '../exceptions/illegal-argument.exception';
import { Matchers } from '../matchers';
import { that } from './that.assert';

export function hasText(
  value: string | null | undefined,
  message: () => string = () => 'value must have text',
  construct: new (message: string) => BaseAssertException = IllegalArgumentException,
): asserts value is NonNullable<string> {
  that(value, Matchers.hasText(message), construct);
}
